/**
 * Filters an observable of a list to return only non-empty lists.
 */

import { Observable } from 'rxjs/Observable';
import { filter } from 'rxjs/operators';
import { pipe } from 'rxjs/util/pipe';

export function notEmpty<T>(): ((
  source: Observable<ReadonlyArray<T>>,
) => Observable<ReadonlyArray<T>>);

export function notEmpty<T>(): ((source: Observable<T[]>) => Observable<T[]>);

export function notEmpty<T>(): ((
  source: Observable<T[]>,
) => Observable<ReadonlyArray<T>>) {
  return pipe(filter(xs => xs.length > 0));
}



// WEBPACK FOOTER //
// ./src/@freelancer/datastore/core/operators/notEmpty.ts